module.exports = __webpack_public_path__ + "static/media/logo.58cbd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 590
// module chunks = 0